import React, { useEffect, useRef, useState } from "react";
import { ABtn, AResult } from "./arcadeUi";
import { sfx } from "@/lib/soundfx";

// Steer your kite under the rival's. Stay aligned to build your PENCH! meter, then cut.
export default function KiteFlying() {
  const boardRef = useRef(null);
  const [youX, setYouX] = useState(30);
  const [rivalX, setRivalX] = useState(70);
  const [tension, setTension] = useState(0); // your advantage
  const [rivalT, setRivalT] = useState(0);
  const [phase, setPhase] = useState("fly"); // fly | over
  const [result, setResult] = useState(null);
  const loop = useRef(null);
  const rivalDir = useRef(1);
  const youRef = useRef(30), rivalRef = useRef(70);
  youRef.current = youX; rivalRef.current = rivalX;

  useEffect(() => {
    loop.current = setInterval(() => {
      // rival drifts
      setRivalX((x) => {
        let nx = x + rivalDir.current * (0.8 + Math.random() * 0.9);
        if (nx > 88) rivalDir.current = -1;
        if (nx < 12) rivalDir.current = 1;
        rivalRef.current = nx;
        return nx;
      });
      const dx = Math.abs(youRef.current - rivalRef.current);
      if (dx < 12) { setTension((t) => Math.min(100, t + 4)); setRivalT((t) => Math.max(0, t - 1)); }
      else { setRivalT((t) => Math.min(100, t + 2)); setTension((t) => Math.max(0, t - 1.5)); }
      setRivalT((t) => { if (t >= 100) { finish(false); } return t; });
    }, 120);
    return () => clearInterval(loop.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const finish = (win) => { clearInterval(loop.current); if (win) sfx.kaipoche(); setResult(win ? "win" : "lose"); setPhase("over"); };

  const steer = (e) => {
    if (phase !== "fly" || !boardRef.current) return;
    const r = boardRef.current.getBoundingClientRect();
    const x = ((e.clientX - r.left) / r.width) * 100;
    setYouX(Math.max(6, Math.min(94, x)));
  };
  const cut = () => { if (phase === "fly" && tension >= 100) finish(true); };

  const reset = () => {
    setYouX(30); setRivalX(70); setTension(0); setRivalT(0); setResult(null); setPhase("fly");
    clearInterval(loop.current);
    rivalDir.current = 1;
    loop.current = setInterval(() => {
      setRivalX((x) => { let nx = x + rivalDir.current * (0.8 + Math.random() * 0.9); if (nx > 88) rivalDir.current = -1; if (nx < 12) rivalDir.current = 1; rivalRef.current = nx; return nx; });
      const dx = Math.abs(youRef.current - rivalRef.current);
      if (dx < 12) { setTension((t) => Math.min(100, t + 4)); setRivalT((t) => Math.max(0, t - 1)); }
      else { setRivalT((t) => Math.min(100, t + 2)); setTension((t) => Math.max(0, t - 1.5)); }
      setRivalT((t) => { if (t >= 100) finish(false); return t; });
    }, 120);
  };

  return (
    <div className="w-full select-none text-center">
      <p className="mb-2 text-sm text-kirana-brown/70">Drag to move your kite under the rival. Align to charge PENCH!, then tap CUT for कट! 🪁</p>
      <div className="mx-auto mb-2 flex max-w-md items-center gap-2 text-xs font-bold">
        <span className="w-12 text-left text-kirana-red">You</span>
        <div className="h-2.5 flex-1 overflow-hidden rounded-full border-2 border-kirana-brown bg-kirana-cream"><div className="h-full bg-kirana-red" style={{ width: `${tension}%` }} data-testid="kite-tension" /></div>
      </div>
      <div className="mx-auto mb-2 flex max-w-md items-center gap-2 text-xs font-bold">
        <span className="w-12 text-left text-kirana-green">Rival</span>
        <div className="h-2.5 flex-1 overflow-hidden rounded-full border-2 border-kirana-brown bg-kirana-cream"><div className="h-full bg-kirana-green" style={{ width: `${rivalT}%` }} /></div>
      </div>

      <div ref={boardRef} data-testid="kite-board" onPointerDown={steer} onPointerMove={(e) => e.buttons && steer(e)}
        style={{ touchAction: "none" }}
        className="relative mx-auto h-56 w-full max-w-md cursor-ew-resize overflow-hidden rounded-lg border-[3px] border-kirana-brown bg-gradient-to-b from-[#8ec5e6] to-[#d9efff]">
        <span data-testid="kite-rival" className="absolute top-6 text-4xl transition-all duration-100" style={{ left: `${rivalX}%`, transform: "translateX(-50%)" }}>🪁</span>
        <span data-testid="kite-you" className="absolute bottom-6 text-4xl" style={{ left: `${youX}%`, transform: "translateX(-50%) scaleX(-1)" }}>🪁</span>
      </div>

      {phase === "fly" ? (
        <div className="mt-4"><ABtn data-testid="kite-cut" onClick={cut} tone={tension >= 100 ? "red" : undefined} disabled={tension < 100} className="px-10 py-3 text-lg">CUT! ✂️</ABtn></div>
      ) : (
        <>
          <AResult testId="kite-result" win={result === "win"} text={result === "win" ? "काई पो छे! You cut it 🎉" : "Rival cut your kite 😜"} />
          <div className="mt-3 flex justify-center"><ABtn data-testid="kite-again" onClick={reset} tone="green">Fly Again</ABtn></div>
        </>
      )}
    </div>
  );
}
